import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import {
	Box,
	Drawer,
	Divider,
	List,
	Button,
	Grid,
	Container,
} from '@mui/material';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const TopDrawer = ({ draw, setDraw, filterAirlineTBO }) => {
	const [tab, setTab] = useState('one');
	const [one, setTabOne] = useState(false);
	const [two, setTabTwo] = useState(false);
	const handleChange = (val) => {
		setTab(val);
	};
	return (
		<>
			<Drawer
				anchor={'top'}
				open={draw}
				PaperProps={{
					sx: { width: '100%' },
				}}
				onClose={() => {
					draw ? setDraw(false) : setDraw(true);
					// dispatch(toggleLoginDrawerModal(false));
				}}
				style={{ width: '100%' }}
				// className={styles.drawerlogin}
				onKeyDown
				classes={{
					paper: { width: '100%' },
				}}>
				<Container style={{ padding: 50 }}>
					<Grid container spacing={2}>
						<Grid item xs={3}>
							<Box>
								<span>Stops</span>
							</Box>
							<Box style={{ display: 'flex' }}>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>Non-Stop</span>
								</Box>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>1 Stop</span>
								</Box>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>1+Stop</span>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={4}>
							<Box>
								<span>Airline</span>
							</Box>
							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{filterAirlineTBO?.map((i, index) => {
									return (
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} size='small' />
											<span style={{ fontSize: 12 }}>{i}</span>
										</Box>
									);
								})}
							</Box>
						</Grid>
						<Grid item xs={3}>
							<Box>
								<span>Fare Type</span>
							</Box>
							<Box style={{ display: 'flex' }}>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>Refundable</span>
								</Box>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>Non-Refundable</span>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={2}>
							<Box
								style={{
									display: 'flex',
									alignItems: 'center',
									cursor: 'pointer',
								}}
								onClick={() => setDraw(false)}>
								Close <i class='fa fa-close' style={{ marginLeft: 5 }}></i>
							</Box>
						</Grid>
					</Grid>
				</Container>
				<Divider />
				<Divider />
			</Drawer>
		</>
	);
};

export default TopDrawer;
